import { TagFilter } from '~/features/common/components/TagFilter';
import { MixPanel } from '~/common';
import { useSearch } from '../../providers';
import { LearnerSearchMixpanelEvents } from '../../constants/mixpanel';

export const AdvancedSearchFilterTags = () => {
  const { selectedTags, setSelectedTags, availableTags, isLoadingTags, setTagSearchTerm } = useSearch();

  return (
    <TagFilter
      tags={availableTags}
      selectedTags={selectedTags}
      isLoading={isLoadingTags}
      onSelectedTagsChange={(tags) => {
        setSelectedTags(tags);
        MixPanel.track(LearnerSearchMixpanelEvents.LEARNER_ADVANCED_SEARCH_SELECTS_TAG);
      }}
      onSelectedTagsClear={() => setSelectedTags([])}
      setTagSearchTerm={setTagSearchTerm}
      size="md"
    />
  );
};
